import { render, staticRenderFns } from "./PersonalSetting.vue?vue&type=template&id=1327ed71&"
import script from "./PersonalSetting.vue?vue&type=script&lang=js&"
export * from "./PersonalSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports